module.exports = __webpack_public_path__ + "static/dark_star-b1354bec65508f5f5bba12f64991b8eb.png";